"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransparencyProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TransparencyContext = (0, react_1.createContext)({
    changeTransparency: () => null,
    initialTransparency: false,
    isTransparent: false,
});
const useTransparency = () => (0, react_1.useContext)(TransparencyContext);
const TransparencyProvider = ({ children, value }) => {
    const [isTransparent, setIsTransparent] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        setIsTransparent(value);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)(TransparencyContext.Provider, { value: {
            changeTransparency: setIsTransparent,
            initialTransparency: !!value,
            isTransparent: !!isTransparent,
        }, children: children }));
};
exports.TransparencyProvider = TransparencyProvider;
exports.default = useTransparency;
